import React from "react";

const LockStudyTopBarIcon = (props) => {
  return (
    props.active ?
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 16 20"
    fill="none"
  >
    <path
      d="M8 0C9.72259 0 11.2309 1.01012 11.7819 2.50665C11.962 2.99609 11.6849 3.52979 11.1628 3.69871C10.6843 3.85355 10.166 3.64812 9.94419 3.23581L9.89129 3.11835C9.61841 2.37709 8.86867 1.875 8 1.875C6.96041 1.875 6.10607 2.61861 6.00916 3.56942L6 3.75L5.99867 6.25H13.3333C14.8061 6.25 16 7.36929 16 8.75V17.5C16 18.8807 14.8061 20 13.3333 20H2.66667C1.19391 20 0 18.8807 0 17.5V8.75C0 7.36929 1.19391 6.25 2.66667 6.25H3.99867L4 3.75C4 1.67893 5.79086 0 8 0ZM8 11.875C7.26362 11.875 6.66667 12.4346 6.66667 13.125C6.66667 13.8154 7.26362 14.375 8 14.375C8.73638 14.375 9.33333 13.8154 9.33333 13.125C9.33333 12.4346 8.73638 11.875 8 11.875Z"
      fill={"green"}
    />
  </svg>
    
    :<svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
    >
      <path
        d="M10.9375 5.33333H10.1562V3.80952C10.1562 1.70667 8.40625 0 6.25 0C4.09375 0 2.34375 1.70667 2.34375 3.80952V5.33333H1.5625C0.703125 5.33333 0 6.01905 0 6.85714V14.4762C0 15.3143 0.703125 16 1.5625 16H10.9375C11.7969 16 12.5 15.3143 12.5 14.4762V6.85714C12.5 6.01905 11.7969 5.33333 10.9375 5.33333ZM6.25 12.1905C5.39062 12.1905 4.6875 11.5048 4.6875 10.6667C4.6875 9.82857 5.39062 9.14286 6.25 9.14286C7.10938 9.14286 7.8125 9.82857 7.8125 10.6667C7.8125 11.5048 7.10938 12.1905 6.25 12.1905ZM3.90625 5.33333V3.80952C3.90625 2.54476 4.95313 1.52381 6.25 1.52381C7.54687 1.52381 8.59375 2.54476 8.59375 3.80952V5.33333H3.90625Z"
        fill={"red"}
      />
    </svg>

    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="30"
    //   height="32"
    //   viewBox="0 0 30 32"
    //   fill="none"
    // >
    //   <rect width="30" height="32" rx="4" fill="black" />
    //   <path
    //     d="M14.8325 9.88002L15 9.875C16.4625 9.875 17.6584 11.0167 17.745 12.4575L17.75 12.625V13.125H18.5C19.3284 13.125 20 13.7966 20 14.625V20.625C20 21.4534 19.3284 22.125 18.5 22.125H11.5C10.6716 22.125 10 21.4534 10 20.625V14.625C10 13.7966 10.6716 13.125 11.5 13.125H12.25V12.625C12.25 11.1625 13.3917 9.9666 14.8325 9.88002L15 9.875L14.8325 9.88002ZM15 16.625C14.4477 16.625 14 17.0727 14 17.625C14 18.1773 14.4477 18.625 15 18.625C15.5523 18.625 16 18.1773 16 17.625C16 17.0727 15.5523 16.625 15 16.625ZM15.1278 11.3815L15 11.375C14.3528 11.375 13.8205 11.8669 13.7565 12.4972L13.75 12.625V13.125H16.25V12.625C16.25 11.9778 15.7581 11.4455 15.1278 11.3815L15 11.375L15.1278 11.3815Z"
    //     fill={props.action?"#FFA800":"#7af156"}
    //   />
    // </svg>
  );
};

export default LockStudyTopBarIcon;
